import { createI18n } from 'vue-i18n';
/*
 * All i18n resources specified in the plugin `include` option can be loaded
 * at once using the import syntax
 */
import messages from '@intlify/vite-plugin-vue-i18n/messages';

const i18n = createI18n({
  legacy: false,
  locale: 'CHS',
  messages,
  globalInjection: true,
});

console.log({ i18n });

window.$i18n = i18n;
export default i18n;
